// extracted by mini-css-extract-plugin
export default {"ModalContent":"DataRoomModals_ModalContent__iRT0x","Heading":"DataRoomModals_Heading__0gn3O","CTAs":"DataRoomModals_CTAs__GD+Fa"};